import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MealsIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MealsGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.26562 20C7.98361 20 7.75541 19.7718 7.75541 19.4898V4.51021C7.75541 4.2282 7.98361 4 8.26562 4C8.54764 4 8.77584 4.2282 8.77584 4.51021V19.4898C8.77584 19.7718 8.54764 20 8.26562 20Z"
        fill={fill}
      />
      <path
        d="M16.3269 20C16.0449 20 15.8167 19.7718 15.8167 19.4898V10.9168C15.8167 10.6348 16.0449 10.4066 16.3269 10.4066C16.6089 10.4066 16.8371 10.6348 16.8371 10.9168V19.4898C16.8371 19.7718 16.6089 20 16.3269 20Z"
        fill={fill}
      />
      <path
        d="M8.3294 10.3518C6.61291 10.3518 5.2168 8.95566 5.2168 7.23967V4.51022C5.2168 4.22821 5.445 4.00001 5.72701 4.00001C6.00903 4.00001 6.23723 4.22821 6.23723 4.51022V7.23967C6.23723 8.39263 7.17594 9.33134 8.3294 9.33134C9.48286 9.33134 10.4216 8.39263 10.4216 7.23967V4.51022C10.4216 4.22821 10.6498 4.00001 10.9318 4.00001C11.2138 4.00001 11.442 4.22821 11.442 4.51022V7.23967C11.442 8.95566 10.0459 10.3518 8.3294 10.3518Z"
        fill={fill}
      />
      <path
        d="M16.3269 11.427C14.5755 11.427 13.1505 9.76183 13.1505 7.714C13.1505 5.66618 14.5755 4 16.3269 4C18.0783 4 19.5028 5.66617 19.5028 7.714C19.5028 9.76184 18.0783 11.427 16.3269 11.427ZM16.3269 5.02043C15.1381 5.02043 14.171 6.2292 14.171 7.714C14.171 9.19881 15.1381 10.4066 16.3269 10.4066C17.5153 10.4066 18.4824 9.19881 18.4824 7.714C18.4824 6.2292 17.5153 5.02043 16.3269 5.02043Z"
        fill={fill}
      />
    </svg>
  );
};

export default MealsIcon;
